/* ------------ -------------- ------------*/
/* ------------  Validate Form ------------*/
/* ------------ -------------- ------------*/

export default  (values) =>{

    const errors = {}
    if (!values.technician_by) {
        errors.technician_by = 'این فیلد ضروری است'
    }

    return errors
};
